import { Editor, Transforms, Range } from "slate";
import { htmlToSlateNodes } from "./utils/serialization";

export const withCustom = (editor) => {
    const { isVoid, isInline, deleteBackward, insertData } = editor;
    editor.isInline = (element) => ["link"].includes(element.type) || isInline(element);
    editor.isVoid = (element) => ["image"].includes(element.type) || isVoid(element);

    editor.deleteBackward = (...args) => {
        const { selection } = editor;

        // Delete empty line if on top of document
        if (
            selection &&
            Range.isCollapsed(selection) &&
            selection.focus.offset === 0 &&
            Editor.string(editor, selection.anchor.path) === ""
        ) {
            const [, parentPath] = Editor.parent(editor, selection.focus.path);
            const pointBefore = Editor.before(editor, parentPath);

            // At start of document: keep the block (Slate requires at least one block)
            if (!pointBefore) {
                return;
            }
        }

        deleteBackward(...args);
    };

    editor.insertData = (data) => {
        const html = data.getData("text/html");
        const plainText = data.getData("text/plain");

        // When we have plain text and either no HTML or HTML has no rich formatting,
        // use plain text directly. Split by double newlines for paragraph breaks,
        // single newlines become soft breaks within each paragraph.
        const usePlainText = plainText && (!html || !/<(strong|b|em|i|a\s|ul|ol|table|h[1-6])/i.test(html));

        if (usePlainText) {
            try {
                const paragraphs = plainText
                    .split(/\r?\n\r?\n|\r\r/)
                    .map((block) => block.trim())
                    .filter((block) => block.length > 0);
                const fragment = paragraphs.map((block) => ({
                    type: "paragraph",
                    children: [{ text: block }]
                }));
                if (fragment.length > 0) {
                    Transforms.insertFragment(editor, fragment);
                    return;
                }
            } catch {
                // Fall through to HTML path
            }
        }

        if (html) {
            try {
                const fragment = htmlToSlateNodes(html);
                if (fragment && fragment.length > 0) {
                    Transforms.insertFragment(editor, fragment);
                    return;
                }
            } catch {
                // Fall through to default on parse error
            }
        }
        if (insertData) {
            insertData(data);
        }
    };

    return editor;
};
